import { render } from "./AllNews.vue?vue&type=template&id=ab8dc524&scoped=true"
import script from "./AllNews.vue?vue&type=script&lang=js"
export * from "./AllNews.vue?vue&type=script&lang=js"

import "./AllNews.vue?vue&type=style&index=0&id=ab8dc524&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab8dc524"]])

export default __exports__